import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class NotPublishedBranchIdError extends Error {
  constructor(reason, payload) {
    super();
    this.reason = reason;
    this.payload = payload;
    _defineProperty(this, "type", 'not-published-branch-id-error');
  }
}
//# sourceMappingURL=types.js.map